import { useBaseFileQuery } from "@query/baseQuery";

export const useFileQuery = (internalUuid) => {
    return useBaseFileQuery(
        {
            endpoint: `/file/${internalUuid}`,
            method: "GET",
            responseType: "blob",
        },
        { enabled: !!internalUuid }
      );
};